// Utility: Update cart badge count
async function updateCartCount() {
  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    const totalQuantity = cart.items ? cart.items.reduce((sum, item) => sum + item.quantity, 0) : 0;

    const cartCountEl = document.querySelector('.cart-count');
    if (cartCountEl) {
      cartCountEl.textContent = totalQuantity;
      cartCountEl.style.display = totalQuantity > 0 ? 'inline-flex' : 'none';
      cartCountEl.style.justifyContent = 'center';
      cartCountEl.style.alignItems = 'center';
      cartCountEl.style.borderRadius = '9999px';
      // console.log('Cart count updated to:', totalQuantity);
    }
  } catch (error) {
    // console.error('Failed to update cart count:', error);
  }
}

// Rebuy Add to Cart Handler
document.addEventListener('click', async function(event) {
  const rebuyButton = event.target.closest('.rebuy-button');
  if (!rebuyButton) return;

  const productBlock = rebuyButton.closest('.rebuy-product-block');
  if (!productBlock) return;

  const productLink = productBlock.querySelector('.rebuy-product-media a[href*="variant="]');
  if (!productLink) {
    console.warn('No product link with variant found inside Rebuy block.');
    return;
  }

  try {
    const href = productLink.getAttribute('href');
    const url = new URL(href, window.location.origin);
    const variantId = url.searchParams.get('variant');
    if (!variantId) {
      console.warn('No variant ID found in URL');
      return;
    }

    // Add product to cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    if (!addResponse.ok) throw new Error('Failed to add product to cart');
    // console.log('Product added to cart');

    // Update badge
    await updateCartCount();

    // Refresh side cart
    const drawerResponse = await fetch('/?section_id=side-cart');
    const drawerHTML = await drawerResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(drawerHTML, 'text/html');
    const newDrawerContent = doc.querySelector('.side-cart');
    const currentDrawer = document.querySelector('.side-cart');
    if (newDrawerContent && currentDrawer) {
      currentDrawer.innerHTML = newDrawerContent.innerHTML;
      document.dispatchEvent(new Event('shopify:section:load'));
    }

    // Open drawer
    if (currentDrawer) {
      currentDrawer.classList.add('active', 'open', 'is-active');
    }

    // Fire Shopify custom events
    const cart = await fetch('/cart.js').then(res => res.json());
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:open'));
  } catch (error) {
    console.error('Error adding product to cart or updating side cart:', error);
  }
});

// 🗑️ Icon Handle Remove Item and Side Cart Close
document.addEventListener('click', async function(event) {
  // 1. Handle side cart close
  const closeBtn = event.target.closest('[data-cart-close]');
  if (closeBtn) {
    const sideCart = document.querySelector('.side-cart');
    if (sideCart) {
      sideCart.classList.remove('active', 'open', 'is-active');
    }
    return;
  }

  // 2. Handle trash icon remove
  const removeBtn = event.target.closest('cart-remove-button');
  if (!removeBtn) return;

  event.preventDefault();

  // Early exit if index not found
  const line = removeBtn.getAttribute('data-index');
  if (!line) {
    console.warn('No data-index found on cart-remove-button');
    return;
  }

  // Store current drawer BEFORE deletion happens
  const currentDrawer = document.querySelector('.side-cart');

  try {
    // Send removal request
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ line: Number(line), quantity: 0 }),
    });

    if (!response.ok) throw new Error('Failed to remove item');

    // Update badge
    await updateCartCount();

    // Refresh drawer HTML from section
    const drawerResponse = await fetch('/?section_id=side-cart');
    const drawerHTML = await drawerResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(drawerHTML, 'text/html');
    const newDrawerContent = doc.querySelector('.side-cart');

    // ⚠ Safe DOM replace using requestAnimationFrame
    if (newDrawerContent && currentDrawer) {
      requestAnimationFrame(() => {
        currentDrawer.innerHTML = newDrawerContent.innerHTML;
        document.dispatchEvent(new Event('shopify:section:load'));
      });
    }
  } catch (error) {
    console.error('Error removing item from cart:', error);
  }
});
